export const setToken = (token) => {
    if (typeof token !== 'string') {
        token = JSON.stringify(token);
    }
    window.localStorage.setItem('adminToken', token);
};

export const getToken = () => {
    return window.localStorage.getItem('adminToken');
};

export const removeToken = () => {
    window.localStorage.removeItem('adminToken');
};

export const isAuth = () => {
    return window.localStorage.getItem('adminToken') !== null;
};
